import { useEffect, useRef, useState } from "react";
import { readTextArr } from "./const";
import IC_RECOLLECT_VOICE from "@/assets/common/ic_recollect_voice.svg?react";
import { convertToWav } from "@/utils/audioBlob2Wav";
import MediaStreamAudio, {
  MediaStreamAudioRef,
} from "@/component/AudioVisualizer/MediaStreamAudio";

export interface IVoiceCollectorProps {
  handleNextStep: (wavBlob: Blob, copyWriting: string) => void;
}

let timer: NodeJS.Timeout;
const audioDuration = 15;

const VoiceCollector: React.FC<IVoiceCollectorProps> = ({ handleNextStep }) => {
  const [count, setCount] = useState(audioDuration);
  const [readText, setReadText] = useState(
    readTextArr[Math.floor(Math.random() * readTextArr.length)]
  );
  const readTextRef = useRef(readText);
  readTextRef.current = readText;
  const mediaStreamAudioRef = useRef<MediaStreamAudioRef>(null);
  const mediaRecorder = useRef<MediaRecorder>();
  const audioChunks = useRef<BlobPart[] | undefined>([]);

  const handleCollect = () => {
    timer && clearInterval(timer);
    timer = setInterval(() => {
      setCount((preCount) => {
        if (preCount === 1) {
          timer && clearInterval(timer);
          stopRecording();
        }
        return preCount - 1;
      });
    }, 1000);
    startRecording();
  };

  const startRecording = async () => {
    await mediaStreamAudioRef.current?.start();
    const stream = mediaStreamAudioRef.current?.getMediaStream();
    if (!stream) {
      startRecording();
      return;
    }
    console.log("startRecording", stream);
    mediaRecorder.current = new MediaRecorder(stream as MediaStream);

    mediaRecorder.current.ondataavailable = (event) => {
      audioChunks.current?.push(event.data);
    };

    mediaRecorder.current.onstop = async () => {
      const audioBlob = new Blob(audioChunks.current, { type: "audio/webm" });
      const wavBlob = await convertToWav(audioBlob);
      handleNextStep(wavBlob as Blob, readTextRef.current);
    };

    mediaRecorder.current.start();
  };
  const handleReCollect = () => {
    audioChunks.current = [];
    setCount(audioDuration);
    const randomIndex = Math.floor(Math.random() * readTextArr.length);
    setReadText(readTextArr[randomIndex]);
    handleCollect();
  };
  // 结束录制，转换成wav文件
  const stopRecording = () => {
    mediaRecorder.current?.stop();
    mediaStreamAudioRef.current?.stop();
  };
  // 录制并开始倒计时
  useEffect(() => {
    handleCollect();
    return () => {
      stopRecording();
    };
  }, []);

  return (
    <div className="w-full h-full flex flex-col items-center justify-center px-15">
      <div className="font-600 text-size-6 text-mx-secondary">
        请朗读<span className="text-mx-quaternary">{`·${count}S`}</span>
      </div>
      <div className="mt-4 text-size-4.5 text-#626773 line-height-8 text-center">
        {readText}
      </div>
      <div className="mt-11.5 w-66.5 h-6">
        <MediaStreamAudio ref={mediaStreamAudioRef} />
      </div>
      <div
        className="flex cursor-pointer items-center justify-center mt-11.5 text-size-3.5 text-#4981F2"
        onClick={handleReCollect}
      >
        重新采集
        <IC_RECOLLECT_VOICE className="ml-2 w-4 h-4" />
      </div>
    </div>
  );
};

export default VoiceCollector;
